import { render } from "./BaseListGroup.vue?vue&type=template&id=de52c8da"
import script from "./BaseListGroup.vue?vue&type=script&lang=js"
export * from "./BaseListGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__